<template>
  <header class="menu" :key="getUser && getUser.id ? getUser.id : 'header-id'">
    <div class="all-row" v-if="!user">
      <div class="menu-item-button item-menu is-mobile">
        <div style="display: flex">
          <img
            src="/static/img/menu_button.svg"
            v-on:click="isMenu"
            class="is-menu-button"
          />
        </div>
      </div>
      <div class="item-menu is-mobile">
        <a href="/">
          <img class="logo-menu-mobile" src="/static/img/logo_full.svg" />
        </a>
      </div>
      <div class="item-menu" style="display: flex;">
        <div v-on:click="isAuthModal" style="cursor:pointer">
          <ui_sub_title_text  style="margin-right: 1em">
            <img src="/static/img/human.svg" />Вход
          </ui_sub_title_text>
        </div>
        
        <div v-on:click="isRegModal" style="cursor:pointer">
          <ui_sub_title_text>
            Регистрация
          </ui_sub_title_text>
        </div>
      </div>
    </div>
    <div class="all-row-logined" v-if="user">
      <div class="menu-item-button item-menu is-mobile">
        <div style="display: flex">
          <img
            src="/static/img/menu_button.svg"
            v-on:click="isMenu"
            class="is-menu-button"
          />
        </div>
      </div>
      <div class="item-menu is-mobile">
        <a href="/">
          <img class="logo-menu-mobile" src="/static/img/logo_full.svg" />
        </a>
      </div>
      <div class="left-menu is-desctop">
        <div class="item-menu left-wrapper">
          <ui_sub_title_text>
            <router-link to="/deals"> Сделки </router-link>
          </ui_sub_title_text>
          <!-- <template v-if="user.role_id == 2">
            <router-link class="margion-none" to="/finance">
              Финансы
            </router-link>
          </template> -->
          <template v-if="user.role_id == 1">
            <ui_sub_title_text>
              <router-link class="margion-none" to="/create_ticket">
                Создать обращение
              </router-link>
            </ui_sub_title_text>
          </template>
          <router-link class="margion-none" to="/safety">
            <ui_sub_title_text>
              О безопасной сделке
            </ui_sub_title_text>
          </router-link>
        </div>
      </div>
      <div class="right-menu">
        <div style="position: relative;" v-on:click="letter" :key="rerender">
          <img src="/static/img/letterIcon.svg" />
          <div v-if="isNew" class="red-point"></div>
        </div>
        <img src="/static/img/colIcon.svg" v-on:click="bellClick" />
        <v-menu
          min-width="330"
          offset-y
          transition="scale-transition"
          class="menu-header"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              style="vertical-align: unset; margin-left: 3%"
              size="61"
              v-bind="attrs"
              v-on="on"
            >
              <img
                style="object-fit: cover"
                :src="user.photo ? `${getApi}file/${user.photo}` : customer1"
                alt=""
              />
            </v-avatar>
          </template>
          <v-card>
            <v-row style="padding: 15px 20px">
              <v-col cols="3">
                <v-avatar style="vertical-align: unset" size="61">
                  <img
                    style="object-fit: cover"
                    :src="
                      user.photo ? `${getApi}file/${user.photo}` : customer1
                    "
                    alt=""
                  />
                </v-avatar>
              </v-col>
              <v-col class="name-email-user">
                <v-row class="name">
                  {{ user.name }} {{ user.patronymic }}
                </v-row>
                <v-row class="email">
                  {{ user.email }}
                </v-row>
              </v-col>
            </v-row>
            <v-list>
              <template v-for="(item, index) in menuitems">
                <v-divider
                  :key="index + Math.floor(Math.random() * (10 - 1 + 1)) + 1+item.title"
                  style="  margin-top: 0 !important; margin-bottom: 0  !important;"
                  v-bind:class="{ 'is-mobile': item.isMobile }"
                />
                <v-list-item v-if="item.met === 'logout'"
                  :key="index + Math.floor(Math.random() * (10 - 1 + 1)) + 1+item.title"
                  link
                  @click="logout()"
                  v-bind:class="{ 'is-mobile': item.isMobile }"
                >
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
                 <v-list-item v-if="item.met != 'logout'"
                  :key="index +Math.floor(Math.random() * (10 - 1 + 1)) + 1+item.title"
                  link
                  :to="item.href"
                  v-bind:class="{ 'is-mobile': item.isMobile }"
                >
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </div>
  </header>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    isAuth: false,
    customer1: "/static/img/customer1.png",
    user: null,
    rerender: false,
    isNew: false,
    menuitems: [],
  }),
  components: {},
  methods: {
    ...mapActions(['setToken', 'setUser']),
    isMenu() {
      this.$root.$refs.menu.isMenu();
    },
    letter() {
      this.$router.push("/chat");
    },
    bellClick() {},
    isAuthModal() {
      this.$root.$emit("modal.auth");
    },
    isRegModal() {
      this.$root.$emit("modal.reg");
    },
    logout(){
      localStorage.removeItem('token')
      this.setToken({token: null, isRemember: true});
      this.setUser = {};
      location.reload();
    }
  },
  mounted() {
    this.$root.$on('all.scroll', () => {
        $('html').scrollTop(0)
    })
    this.$root.$on('open.new.message', () => {
      this.isNew = false;
    });
    this.$root.$on('dot.action', () => {
      this.isNew = true;
      this.rerender = !this.rerender;
    });
  },
  watch: {
    getUser(to, from) {
      this.user = this.getUser;
      if (this.user.role_id == 2) {
        this.menuitems = [
          { title: "Профиль", href: `/profile` },
          { title: "Сделки", href: "/deals"},
          { title: "Поддержка", href: "/support" },
          // { title: "Финансы", href: "/finance" },
          { title: "Настройка", href: "/preferences" },
          { title: "О безопасной сделке", href: "/safety" },
          { title: "Выйти", href: "/Logout", met: "logout" },
        ];
      } else {
        this.menuitems = [
          { title: "Профиль", href: `/profile` },
          { title: "Сделки", href: "/deals"},
          {
            title: "Создать обращение",
            href: "/create_ticket",
          },
          { title: "Поддержка", href: "/support" },
          { title: "Настройка", href: "/preferences" },
          { title: "О безопасной сделке", href: "/safety" },
          { title: "Выйти", href: "/Logout",met: "logout" },
        ];
      }
    },
  },
  computed: {
    ...mapGetters(["getUser", "getLk", "getApi"]),
  },
};
</script>

<style>
.menu-item-button{
  width: 52px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ECECEC;
  border-radius: 40px;
  margin-right: 10px;
}
.menu-item-button img{
  margin: 0 !important;
}
.left-wrapper{
  display: flex;
}
.left-wrapper .ui-sub-title-text:not(:last-child){
  margin-right: 62px;
}

.name-email-user {
  font-family: 'Helvetica';
  place-self: center;
  margin-left: 1em;
}
.name-email-user .name {
  font-size: 16px;
  font-weight: bolder;
}
.name-email-user .email {
  font-size: 12px;
}

.hr {
  margin-top: 0 !important;
  margin-bottom: 0  !important;
}

.right-menu img:hover {
  background-color: #ffffff !important;
  border-radius: 100%;
}

.menu-header .v-menu__content .v-list-item {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  
  color: #000000 !important;
}

.v-application a {
  color: #000000 !important;
}

.menu-header .v-list-item__title {
  text-align-last: left;
}

.right-menu {
  display: flex;
  cursor: pointer;
  margin-right: 5%;
}

.left-menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.all-row-logined {
  justify-content: space-between;
}

.all-row-logined {
  display: flex;
  margin-left: 5%;
}
.all-row {
  display: flex;
  justify-content: flex-end;
}

.menu {
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.item-menu img {
  vertical-align: baseline;
  margin-right: 10px;
}


@media (max-width: 1150px) {
  .menu {
    /* margin-right: 4.5%; */
  }
}

@media (max-width: 750px) {
  .item-menu{
    align-items: center;
  }
  .item-menu .ui-sub-title-text{
    display: flex;
    align-items: center;
  }
  .all-row-logined{
      align-items: center;
  }
  .logo-menu-mobile {
    width: 85px !important;
    height: auto !important;
  }
  .menu {
    height: 69px;
    margin-right: 0;
    background-color: white;
    width: 100%;
  }

  .item-menu img {
    height: 30px;
    width: 10px;
  }
  .all-row {
    justify-content: space-around;
  }
  .margion-none {
    margin: 0 !important;
  }

  .is-menu-button {
    width: 42px !important;
  }
  .right-menu img {
    height: 30px;
    width: 30px;
  }
  .right-menu .v-avatar {
    height: 30px !important;
    width: 30px !important;
    min-width: 30px !important;
  }
}

@media (max-width: 750px) {
  .is-desctop {
    display: none;
  }
  .all-row {
    align-items: center;
  }
}
@media (min-width: 750px) {
  .all-row {
    margin-right: 9.5%;
  }
  .all-row-logined {
    margin-left: 15%;
  }
  .is-mobile {
    display: none;
  }
}
.red-point{
    background: indianred;
    height: 1em;
    width: 1em;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 1em;
}
</style>


// WEBPACK FOOTER //
// header.vue?e26fe124